/*
  dd-event-identity.js — CANONICAL event / toolkit identity (JS runtime)

  Single source of truth for "is this line/variant a Method LIVE event ticket,
  the Business-In-A-Box toolkit, the online course, or the With-Toolkit seat?"
  Exposed as window.DDEventIdentity. Consumers: dd-shipping-protection.js,
  dd-event-xsell-toolkit.js (loaded AFTER this file).

  MIRROR: snippets/dd-event-identity.liquid holds the same constants/logic for
  the Liquid runtime (SSR). If you change an id / sku / handle / keyword here,
  change it there too — the two runtimes cannot share code without a build step.
  The non-shippable gate also mirrors notifications/order-confirmation.liquid.

  Pure, synchronous, side-effect-free. No Shopify requests. Idempotent load.
*/
(function () {
  'use strict';
  if (window.DDEventIdentity) return;

  // Method LIVE event ticket. Handle is stable across event dates; SKUs and
  // variant ids rotate, so match handle/title first, then the known ids.
  var EVENT_HANDLE = 'drop-dead-method-live';
  var EVENT_TITLE_KEYWORDS = ['method live'];
  var EVENT_SKUS = ['35915809050190', '35915809050191'];
  var EVENT_VARIANT_IDS = ['51873866285373', '51873866318141'];

  // Business In A Box Training Toolkit.
  var BIAB_PRODUCT_ID = '9043506626877';
  var BIAB_HANDLE = 'business-in-a-box-training-toolkit';
  var BIAB_TITLE_KEYWORDS = ['business in a box', 'business-in-a-box'];

  // Method online course.
  var COURSE_HANDLE = 'learn-the-drop-dead-method-online-course';
  var COURSE_PRODUCT_TITLE = 'drop dead method';

  function lc(v) {
    return v == null ? '' : String(v).toLowerCase();
  }
  function hasAny(hay, needles) {
    for (var i = 0; i < needles.length; i++) {
      if (hay.indexOf(needles[i]) !== -1) return true;
    }
    return false;
  }
  function inList(value, list) {
    var v = value == null ? '' : String(value);
    for (var i = 0; i < list.length; i++) {
      if (list[i] === v) return true;
    }
    return false;
  }

  // Reads identity fields from either a cart line item or a product-ish object.
  function fields(item) {
    item = item || {};
    return {
      handle: lc(item.handle || (item.product && item.product.handle)),
      title: lc(item.title),
      productTitle: lc(item.product_title || (item.product && item.product.title)),
      sku: String(item.sku || ''),
      variantId: String(item.variant_id || (item.variant && item.variant.id) || ''),
      productId: String(item.product_id || (item.product && item.product.id) || '')
    };
  }

  function isEventTicketItem(item) {
    if (!item) return false;
    var f = fields(item);
    return f.handle === EVENT_HANDLE
      || hasAny(f.productTitle, EVENT_TITLE_KEYWORDS)
      || hasAny(f.title, EVENT_TITLE_KEYWORDS)
      || inList(f.sku, EVENT_SKUS)
      || inList(f.variantId, EVENT_VARIANT_IDS);
  }

  function isBiabToolkitItem(item) {
    if (!item) return false;
    var f = fields(item);
    return f.productId === BIAB_PRODUCT_ID
      || f.handle === BIAB_HANDLE
      || hasAny(f.title, BIAB_TITLE_KEYWORDS)
      || hasAny(f.productTitle, BIAB_TITLE_KEYWORDS);
  }

  function isOnlineCourseItem(item) {
    if (!item) return false;
    var f = fields(item);
    return f.handle === COURSE_HANDLE || f.productTitle === COURSE_PRODUCT_TITLE;
  }

  function cartHasEventTicket(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (isEventTicketItem(items[i])) return true;
    }
    return false;
  }

  // "With Toolkit" seat/variant = mentions a toolkit and is NOT the
  // "Without Toolkit" / "bring your own" option.
  function isWithToolkitText(text) {
    var s = lc(text);
    if (s.indexOf('toolkit') === -1) return false;
    if (s.indexOf('without toolkit') !== -1) return false;
    if (s.indexOf('bring your own') !== -1) return false;
    return true;
  }

  function isWithToolkitVariant(variant) {
    if (!variant) return false;
    var parts = [];
    if (variant.title) parts.push(variant.title);
    if (variant.public_title) parts.push(variant.public_title);
    if (variant.options && variant.options.length) {
      parts = parts.concat(variant.options);
    }
    return isWithToolkitText(parts.join(' '));
  }

  // Non-shippable gate. `hasEventTicket` is a cart-level flag callers precompute
  // once (via cartHasEventTicket) so the BIAB rule doesn't rescan per item.
  // Order mirrors dd-shipping-protection.js's prior inline logic.
  function isNonShippableItem(item, hasEventTicket) {
    if (!item) return true;
    if (item.requires_shipping === false) return true;
    if (item.gift_card === true) return true;
    if (isOnlineCourseItem(item)) return true;
    if (isEventTicketItem(item)) return true;
    // BIAB is non-shippable ONLY alongside an event ticket (picked up at the
    // event). Bought standalone it ships and is insurable.
    if (isBiabToolkitItem(item)) return !!hasEventTicket;
    return false;
  }

  window.DDEventIdentity = {
    isEventTicketItem: isEventTicketItem,
    isBiabToolkitItem: isBiabToolkitItem,
    isOnlineCourseItem: isOnlineCourseItem,
    cartHasEventTicket: cartHasEventTicket,
    isWithToolkitText: isWithToolkitText,
    isWithToolkitVariant: isWithToolkitVariant,
    isNonShippableItem: isNonShippableItem
  };
})();
